<template>
  <div class="section__acceleration p-0">
    <modal-order/>
    <div class="row align-items-stretch">
      <div class="col section__acceleration-description mb-5">
        <div class="title-with-icon mb-4">
          <div class="title-with-icon__icon title-with-icon__icon_partner"></div>
          <div class="title-with-icon__title">Для экспертов</div>
        </div>
        <div class="section__acceleration-description-text mb-5">
          <p>Школа экспорта РЭЦ на постоянной основе реализует образовательные программы для экспортно ориентированных предприятий (программу экспортных семинаров, акселерационные программы «Экспортный форсаж» и «Акселератор экспортного роста») и программу для региональных управленческих команд «Экспорт регионов 2.0.».</p>
          <p>Участие предприятий и региональных управленческих команд в программах позволяет получить информационно-образовательную поддержку для выхода на международный уровень торговли, повышения эффективности экспортных поставок и разработки проекта региональной программы развития экспорта субъекта РФ.</p>
          <p>Для реализации данных программ Школа экспорта РЭЦ формирует сообщество экспертов для оказания образовательных и информационно-консультационных услуг на возмездной основе.</p>
        </div>
        <div class="section__acceleration-description-text mb-5">
          <p>Мы приглашаем к сотрудничеству экспертов в следующих областях:</p>
          <ul>
            <li>внешнеэкономическая деятельность</li>
            <li>экспортные и инвестиционные проекты</li>
            <li>экономика и финансы</li>
            <li>экспортный маркетинг и продажи</li>
            <li>финансовое планирование экспортной деятельности</li>
            <li>развитие кадрового потенциала</li>
            <li>страновая специфика дружественных стран</li>
            <li>разработка стратегий социально-экономического, экспортного развития субъектов РФ</li>
            <li>экспорт услуг (образовательные, туристические, медицинские, креативные индустрии)</li>
            <li>экспорт физических товаров</li>
            <li>проектное управление</li>
          </ul>
        </div>
      </div>
      <div class="col-md-4 mb-3 mb-md-0 section__acceleration-tag">
        <div class="container-shadow p-24 fill-white">
          <div class="section__acceleration-tag-img mb-24">
            <img src="/pic/block-tlnt.jpeg" class="object-fit-cover"/>
          </div>
          <div class="section__acceleration-tag-title">
            Пройдите предварительный тест, чтобы определить уровень вашей экспертизы в сфере внешнеэкономической деятельности!
          </div>
          <a href="/lk/recommend" class="link-target"><span>Пройти тест</span></a>
        </div>
      </div>
    </div>
    <div class="section__acceleration-target" style="padding: 0;!important;">
      <div class="row">
        <div class="col-md-6">
          <h2 class="mt-4 mb-4">Возможности для экспертов</h2>
          <div class="item-content mb-4">
            <p>Вы можете выбрать различные варианты сотрудничества со Школой экспорта РЭЦ</p>
          </div>
        </div>
      </div>
    </div>
    <div class="section__acceleration-key container-grid">
      <div class="container-grid__item">
        <div class="container-shadow p-24 fill-white">
          <svg width="144" height="144" viewBox="0 0 144 144" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_841_37160)">
              <path d="M135.888 71.9004C135.888 62.0885 130.811 53.1098 122.662 48.0113C124.465 42.6018 124.199 36.504 121.428 31.025C118.761 25.7479 114.197 21.8256 108.579 19.9806C108.257 19.8748 107.933 19.7786 107.609 19.6881C107.648 19.1992 107.673 18.7079 107.674 18.2129C107.677 13.327 105.738 8.73731 102.215 5.28863C98.7305 1.87819 94.125 0 89.247 0C82.1899 0 75.9177 3.42225 72.0002 8.69316C68.0827 3.42225 61.8105 0 54.7534 0C49.8754 0 45.2699 1.87819 41.7858 5.28863C38.2623 8.73731 36.3236 13.3273 36.3267 18.2132C36.327 18.7082 36.3523 19.1995 36.3917 19.6883C36.0674 19.7789 35.7437 19.8751 35.422 19.9808C29.8037 21.8256 25.2404 25.7482 22.5722 31.0252C19.8022 36.504 19.5356 42.6018 21.3389 48.0116C13.1894 53.1101 8.1123 62.0887 8.1123 71.9007C8.1123 81.765 13.2074 90.7388 21.3966 95.8261C19.533 101.276 19.7743 107.441 22.5722 112.975C25.2401 118.252 29.8037 122.174 35.422 124.019C35.744 124.125 36.0674 124.221 36.392 124.312C36.3526 124.801 36.3273 125.292 36.327 125.787C36.3239 130.673 38.2626 135.263 41.7861 138.711C45.2699 142.122 49.8754 144 54.7534 144C61.8105 144 68.0824 140.578 72.0002 135.307C75.9177 140.578 82.1899 144 89.247 144C94.125 144 98.7305 142.122 102.215 138.711C105.738 135.263 107.677 130.673 107.674 125.787C107.673 125.292 107.648 124.8 107.609 124.312C107.933 124.221 108.257 124.125 108.578 124.019C114.197 122.174 118.76 118.252 121.428 112.975C124.226 107.441 124.467 101.276 122.604 95.8258C130.793 90.7386 135.888 81.7647 135.888 71.9004ZM16.5754 71.9004C16.5754 65.1682 19.9926 58.9981 25.5017 55.3967C26.8379 56.9641 28.411 58.3602 30.1989 59.5294C30.8441 64.1329 33.2066 68.1924 36.6198 71.0347C32.7096 74.2911 30.1789 79.1451 30.0301 84.5842C28.3603 85.6986 26.8818 87.0117 25.6122 88.4784C20.0336 84.8919 16.5754 78.6982 16.5754 71.9004ZM54.7534 135.537C52.1018 135.537 49.5986 134.516 47.7056 132.663C45.8237 130.821 44.7881 128.381 44.7898 125.792C44.7901 125.524 44.8036 125.258 44.825 124.994C47.4021 124.7 49.9336 123.948 52.3172 122.743L48.4987 115.19C45.239 116.838 41.5321 117.118 38.0623 115.979C34.592 114.839 31.773 112.416 30.1249 109.156C27.4963 103.957 28.517 97.8567 32.2194 93.7814C35.3168 99.4899 41.3648 103.375 48.3035 103.375V94.9117C42.8875 94.9117 38.4808 90.5054 38.4808 85.0891C38.4808 79.6728 42.8872 75.2667 48.3035 75.2667V66.8033C42.8875 66.8033 38.4808 62.397 38.4808 56.9807C38.4808 51.5644 42.8872 47.158 48.3035 47.158V38.6947C40.881 38.6947 34.4823 43.1423 31.6197 49.5104C28.4143 45.4579 27.6448 39.7493 30.1252 34.8432C31.7733 31.5835 34.5923 29.1606 38.0626 28.0209C41.533 26.8813 45.2396 27.1614 48.499 28.8096L52.3175 21.2569C49.9339 20.0517 47.4024 19.3027 44.8256 19.0091C44.8039 18.7436 44.7904 18.4764 44.7901 18.207C44.7884 15.6181 45.824 13.1783 47.7058 11.3361C49.5989 9.48291 52.1021 8.46253 54.7537 8.46253C61.9303 8.46253 67.7688 14.301 67.7688 21.4777V122.521C67.7685 129.698 61.9301 135.537 54.7534 135.537ZM113.876 109.156C112.228 112.416 109.409 114.839 105.938 115.979C102.468 117.118 98.7617 116.838 95.502 115.19L91.6835 122.743C94.0674 123.948 96.5986 124.7 99.1757 124.994C99.1971 125.258 99.2109 125.524 99.2109 125.792C99.2126 128.381 98.177 130.821 96.2952 132.663C94.4021 134.517 91.8989 135.537 89.2473 135.537C82.0706 135.537 76.2322 129.698 76.2322 122.522V21.4782C76.2322 14.3016 82.0706 8.46309 89.2473 8.46309C91.8989 8.46309 94.4021 9.48347 96.2952 11.3366C98.177 13.1785 99.2126 15.6187 99.2109 18.2073C99.2106 18.4767 99.1971 18.7439 99.1754 19.0094C96.5986 19.303 94.0671 20.0517 91.6835 21.2572L95.502 28.8098C98.7623 27.1617 102.469 26.8822 105.938 28.0212C109.409 29.1608 112.228 31.5835 113.876 34.8435C116.356 39.7496 115.587 45.4579 112.381 49.5107C109.519 43.1426 103.12 38.6949 95.6975 38.6949V47.1583C101.114 47.1583 105.52 51.5647 105.52 56.981C105.52 62.3973 101.114 66.8036 95.6975 66.8036V75.267C101.114 75.267 105.52 79.6733 105.52 85.0894C105.52 90.5054 101.114 94.912 95.6975 94.912V103.375C102.636 103.375 108.684 99.4902 111.782 93.7817C115.484 97.8567 116.504 103.957 113.876 109.156ZM118.388 88.4787C117.118 87.012 115.64 85.6988 113.97 84.5845C113.822 79.1452 111.291 74.2913 107.38 71.035C110.794 68.1927 113.156 64.1332 113.801 59.5297C115.589 58.3602 117.162 56.9644 118.498 55.397C124.008 58.9984 127.425 65.1684 127.425 71.9007C127.425 78.6982 123.967 84.8919 118.388 88.4787Z" fill="#1C75BC"/>
            </g>
            <defs>
              <clipPath id="clip0_841_37160">
                <rect width="144" height="144" fill="white"/>
              </clipPath>
            </defs>
          </svg>
          <h2>Автор-разработчик</h2>
          <div class="subtitle">
            <ul>
              <li>в соответствии с задачами и по требуемому направлению разрабатывает тематические блоки/курсы/дисциплины/модули образовательной программы и проводит обучение</li>
              <li>разрабатывает учебно-методические и контрольно-измерительные материалы</li>
              <li>оказывает консультационные услуги</li>
              <li>участвует в итоговой аттестации</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="container-grid__item">
        <div class="container-shadow p-24 fill-white">
          <svg width="144" height="144" viewBox="0 0 144 144" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_841_37145)">
              <path d="M142.843 81.2675L142.706 81L131.52 65.1566C131.215 52.3046 126.069 40.2635 116.953 31.1355C107.55 21.7207 95.0434 16.229 81.7372 16.229C73.8158 16.229 68.8598 17.5275 67.7402 17.7578C66.6354 7.78359 58.1549 0 47.8913 0C36.8809 0 27.9228 8.95697 27.9205 19.9668H24.6639C11.0644 19.9668 0 31.0312 0 44.631C0 58.2308 11.0644 69.2949 24.6639 69.2949H39.5716V75.1435L8.25412 82.8011V100.209C3.44222 101.976 0 106.605 0 112.022C0 118.958 5.64272 124.601 12.5789 124.601C19.5151 124.601 25.1578 118.958 25.1578 112.022C25.1578 106.526 21.6135 101.845 16.6916 100.137V89.4243L39.5719 83.8294V90.5048C34.7051 92.243 31.2117 96.8971 31.2117 102.354C31.2117 109.29 36.8544 114.933 43.7906 114.933C45.2413 114.933 46.6341 114.683 47.932 114.229V144H102.772V124.833H115.995C121.686 124.833 127.099 122.378 130.848 118.095C134.595 113.812 136.313 108.121 135.558 102.481L134.803 96.8349L137.098 95.9867C139.928 94.9407 142.18 92.729 143.278 89.9182C144.375 87.1073 144.217 83.9545 142.843 81.2675ZM16.72 112.022C16.72 114.305 14.8624 116.163 12.5786 116.163C10.2949 116.163 8.4375 114.305 8.4375 112.022C8.4375 109.738 10.2952 107.88 12.5789 107.88C14.8627 107.88 16.72 109.738 16.72 112.022ZM24.6639 60.8574C15.7168 60.8574 8.4375 53.5781 8.4375 44.631C8.4375 35.6839 15.7168 28.4046 24.6639 28.4046H36.358V19.9707C36.358 13.6114 41.5319 8.4375 47.8913 8.4375C54.2506 8.4375 59.4245 13.6114 59.4245 19.9707V29.2292C61.6995 26.6678 65.0157 25.0523 68.7108 25.0523C75.5696 25.0523 81.1299 30.6127 81.1299 37.4715C81.1299 38.3172 81.0447 39.143 80.8836 39.9414H85.4052C91.172 39.9414 95.8635 44.633 95.8635 50.3994C95.8635 56.1662 91.172 60.8577 85.4052 60.8577H24.6639V60.8574ZM43.7903 106.495C41.5069 106.495 39.6489 104.637 39.6489 102.353C39.6489 100.07 41.5066 98.2119 43.7903 98.2119C46.0741 98.2119 47.9317 100.07 47.9317 102.353C47.9317 104.637 46.0738 106.495 43.7903 106.495ZM135.417 86.85C135.288 87.183 134.953 87.7838 134.173 88.0726L125.545 91.2611L127.194 103.599C127.626 106.828 126.643 110.086 124.498 112.538C122.352 114.99 119.253 116.396 115.995 116.396H94.3344V135.562H56.3692V102.267L56.367 102.268C56.3307 96.8487 52.8503 92.2337 48.0091 90.5048V83.7832L71.0786 89.4246V100.173C66.2119 101.911 62.7188 106.565 62.7188 112.022C62.7188 118.958 68.3615 124.601 75.2977 124.601C82.2338 124.601 87.8766 118.958 87.8766 112.022C87.8766 106.565 84.3834 101.911 79.5164 100.173V82.8011L48.0094 75.0971V69.2947H85.4055C95.8247 69.2947 104.301 60.8181 104.301 50.3989C104.301 40.8262 97.1457 32.8936 87.9024 31.6676C87.5213 29.2801 86.636 27.0599 85.365 25.1137C106.479 26.9885 123.097 44.7834 123.097 66.3688V67.8549L135.422 85.3116C135.679 85.9697 135.535 86.5482 135.417 86.85ZM71.1562 112.022C71.1562 109.738 73.0139 107.88 75.2977 107.88C77.5814 107.88 79.4391 109.738 79.4391 112.022C79.4391 114.306 77.5814 116.163 75.2977 116.163C73.0139 116.163 71.1562 114.305 71.1562 112.022Z" fill="#1C75BC"/>
            </g>
            <defs>
              <clipPath id="clip0_841_37145">
                <rect width="144" height="144" fill="white"/>
              </clipPath>
            </defs>
          </svg>
          <h2>Приглашенный преподаватель</h2>
          <div class="subtitle">
            <ul>
              <li>проводит обучение по дисциплинам/курсам программ Школы экспорта</li>
              <li>оказывает консультационные услуги</li>
              <li>участвует в итоговой аттестации</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="container-grid__item">
        <div class="container-shadow p-24 fill-white">
          <svg width="144" height="144" viewBox="0 0 144 144" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_1499_54302)">
              <path d="M103.238 0H21.1765V16.9412H4.23535V144H139.765V31.9604L103.238 0ZM105.882 13.569L124.257 29.6471H105.882V13.569ZM12.7059 135.529V25.4118H21.1765V135.529H12.7059ZM29.6471 135.529V8.47059H97.4118V38.1176H131.294V135.529H29.6471Z" fill="#1C75BC"/>
              <path d="M84.7059 51.0879V42.353H76.2353V51.0879C60.9321 53.0048 48.7694 65.1674 46.8525 80.4707H38.1177V88.9413H46.8525C48.7694 104.245 60.9321 116.407 76.2353 118.324V127.059H84.7059V118.324C100.009 116.407 112.172 104.245 114.089 88.9413H122.824V80.4707H114.089C112.172 65.1674 100.009 53.0048 84.7059 51.0879ZM105.527 80.4707H96.8756C95.3399 74.526 90.65 69.8364 84.7056 68.3007V59.6488C95.3311 61.4395 103.737 69.8455 105.527 80.4707ZM80.4706 93.1766C75.7999 93.1766 72 89.3767 72 84.706C72 80.0353 75.7999 76.2354 80.4706 76.2354C85.1413 76.2354 88.9412 80.0353 88.9412 84.706C88.9412 89.3767 85.1413 93.1766 80.4706 93.1766ZM76.2353 59.6491V68.301C70.2909 69.8364 65.6011 74.5263 64.0653 80.471H55.4135C57.2042 69.8455 65.6101 61.4395 76.2353 59.6491ZM55.4138 88.9413H64.0656C65.6011 94.8859 70.2912 99.5755 76.2356 101.111V109.763C65.6101 107.972 57.2042 99.5665 55.4138 88.9413ZM84.7059 109.763V101.111C90.6503 99.5752 95.3402 94.8856 96.8759 88.941H105.528C103.737 99.5665 95.3311 107.972 84.7059 109.763Z" fill="#1C75BC"/>
              <path d="M38.1177 21.1765H80.4706V29.6471H38.1177V21.1765Z" fill="#1C75BC"/>
            </g>
            <defs>
              <clipPath id="clip0_1499_54302">
                <rect width="144" height="144" fill="white"/>
              </clipPath>
            </defs>
          </svg>
          <h2>Эксперт-консультант</h2>
          <div class="subtitle">
            <ul>
              <li>проводит обучение по узкоспециализированным кейсам</li>
              <li>оказывает консультационные услуги, в том числе по решению практических задач</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="section__acceleration-content mt-6 mb-0">
      <h2 class="mb-5">Ключевые задачи (зависят от выбранной роли)</h2>
      <div class="section__acceleration-content-steps">
        <div class="section__acceleration-content-step">
          <div class="section__acceleration-content-step-wrapper">
            <h2>Разработка тематического блока/курса/дисциплины/модуля образовательной программы</h2>
            <div class="item-content">
              Разработка включает в себя подготовку лекционного материала, рабочей тетради для слушателя, презентации, контрольно-измерительных материалов для проведения аттестации слушателей
            </div>
          </div>
        </div>
        <div class="section__acceleration-content-step">
          <div class="section__acceleration-content-step-wrapper">
            <h2>Проведение обучения</h2>
            <div class="item-content">
              Обучение предполагает проведение занятий по курсам/дисциплинам/модулям образовательных программ Школы экспорта РЭЦ в соответствии с установленными требованиями
            </div>
          </div>
        </div>
        <div class="section__acceleration-content-step">
          <div class="section__acceleration-content-step-wrapper">
            <h2>Участие в аттестации</h2>
            <div class="item-content">
              Проведение итоговой проверки знаний по курсам/дисциплинам/модулям образовательных программ Школы экспорта РЭЦ в составе аттестационной комиссии соответствующей образовательной программы
            </div>
          </div>
        </div>
        <div class="section__acceleration-content-step">
          <div class="section__acceleration-content-step-wrapper">
            <h2>Консультационные услуги </h2>
            <div class="item-content">
              Проведение консультаций экспертом по вопросам, соответствующим заявленной области профессиональной экспертизы, в том числе по решению конкретных практических задач
            </div>
          </div>
        </div>
        <div class="section__acceleration-content-step">
          <div class="section__acceleration-content-step-wrapper">
            <h2>Проведение мероприятий (семинаров, конференций, мастер-классов)</h2>
            <div class="item-content">
              Проведение мероприятий предполагает разработку или адаптацию материалов для семинаров, конференций, мастер-классов (презентации и раздаточные материалы) и выступление в качестве спикера на данных мероприятиях
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="accordion" id="vacancy-accordion">
      <div class="accordion__item container-shadow">
        <div class="accordion__header" id="headingVacancy" :style="{cursor: 'default'}">
          <h2>Процедура подачи заявки</h2>
        </div>
        <div class="collapse accordion__body show" :style="{cursor: 'default'}">
          <div class="section__acceleration-description-text mb-2">
            <p>
              Процедура подачи и обработки заявок для включения кандидатов в экспертную базу Школы экспорта РЭЦ проходит в несколько этапов:
            </p>
          </div>
          <div class="section__acceleration-description-text mb-2">
            <ul class="list">
              <li>Зарегистрируйтесь на сайте Школы экспорта РЭЦ и предоставьте согласие на обработку персональных данных</li>
              <li>Выберите вариант сотрудничества со Школой экспорта РЭЦ</li>
              <li>Заполните первичную заявку кандидата</li>
              <li>Дождитесь ответа сотрудника Школы экспорта РЭЦ (в течение 1 недели) на свой e-mail о соответствии/несоответствии квалификационным требованиям, установленным Школой экспорта РЭЦ</li>
              <li>Кандидатам, чья квалификация соответствует требованиям Школы экспорта РЭЦ, будет предложено пройти процедуру <b class="text-blue" id="tooltip">отбора</b> для окончательного решения о включении в экспертную базу</li>
              <li>Кандидаты, успешно прошедшие отбор и включенные в экспертную базу, получают приглашения на оказание образовательных и информационно-консультационных услуг для Школы экспорта РЭЦ по мере возникновения такой потребности</li>
            </ul>
            <div class="mt-5">
              <a @click="showOrder()" :style="{cursor: 'pointer'}" class="link-target link-target-button">
                <span>подать заявку</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-10">
      <h2 class="mb-4">Контактная информация</h2>
      <nav class="header__navigation-menu inline-menu">
        <ul>
          <li><a href="mailto:cv@exportedu.ru" class="header__navigation-menu-email">cv@exportedu.ru</a></li>
          <li><a href="tel:+7 (495) 937-4742" class="header__navigation-menu-phone">+7 (495) 937-4742</a></li>
          <li><a href="#" class="header__navigation-menu-location">123610, Москва, Краснопресненская наб. 12, подъезд
            9</a></li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
import tippy from "tippy.js";
import ModalOrder from "@/components/tutors/ModalOrder.vue";
import $ from 'jquery';
import 'bootstrap'
import {TokenService} from "../../../services/token.service";
export default {
  name: "Vacancy",
  components: {ModalOrder},
  data() {
    return {
      user: JSON.parse(TokenService.getUser())
    }
  },
  mounted() {

    if(this.$route.query.order === 'open') {
      this.showOrder()
    }

    tippy('#tooltip', {
      content: 'Заполнение развернутой анкеты и проведение собеседования в онлайн-формате. Неполные или неправильно заполненные анкеты будут исключены из рассмотрения',
    });
  },
  methods: {
    showOrder() {
      if(this.user) {
        $('#order-modal').modal('show')
      } else {
        this.$router.push('/sign-in')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.link-target {
  &:hover {
    color: #fff;
   }
}
.list {
  list-style: none;
  margin-left: 2rem;
  li {
    padding: 1rem 1rem 1rem;
    &::before {
      width: 0.6rem;
      height: 0.6rem;
      border-radius: 50%;
      background-color: #ED1B2F;
      content: "";
      display: inline-block;
      margin-left: -1rem;
      margin-right: 1.5rem;
      position: relative;
      top: -0.2rem;
      @media (max-width: 767px) {
        width: 6px;
        height: 6px;
      }
    }
  }
}
.accordion__header h2:after {
  display: none!important;
}
.inline-menu {
  position: relative!important;
  top: auto;
  right: auto;
}
</style>